export default __webpack_public_path__ + "static/media/living-room.301d65ab.jpg";